import { useRef, useState } from 'react';
import * as ImageManipulator from 'expo-image-manipulator';
import { fontPalette } from '../static/styles/global';

const MINIMUM_DRAW_DISTANCE = 20;
const MINIMUM_POINTS_IN_STROKE = 5;

const Canvas = ({ setSignatureDataURL, setHasDrawn, hasDrawn }) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [strokePoints, setStrokePoints] = useState([]);
  const [hasValidStroke, setHasValidStroke] = useState(false);

  const calculateStrokeDistance = (points) => {
    let totalDistance = 0;
    if (!points || points.length < MINIMUM_POINTS_IN_STROKE) return 0;
    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      totalDistance += Math.sqrt(dx * dx + dy * dy);
    }
    return totalDistance;
  };

  const handleStrokesChange = () => {
    const distance = calculateStrokeDistance(strokePoints);
    if (distance > MINIMUM_DRAW_DISTANCE) {
      setHasValidStroke(true);
      saveCanvas();
      setHasDrawn(true);
    }
  };

  const saveCanvas = async () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const dataUrl = canvas.toDataURL();
    const resizedImage = await ImageManipulator.manipulateAsync(
      dataUrl,
      [{ resize: { width: 200, height: 50 } }],
      { format: ImageManipulator.SaveFormat.PNG }
    );
    setSignatureDataURL(resizedImage.uri);
  };

  const getCoordinates = (event) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();

    if (event.touches && event.touches.length > 0) {
      const touch = event.touches[0];
      return {
        x: touch.clientX - rect.left,
        y: touch.clientY - rect.top,
      };
    } else {
      return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      };
    }
  };

  const startDrawing = (event) => {
    // event.preventDefault();
    const { x, y } = getCoordinates(event);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
    setStrokePoints([{ x, y }]);
  };

  const draw = (event) => {
    // event.preventDefault();
    if (!isDrawing) return;
    const { x, y } = getCoordinates(event);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    ctx.lineTo(x, y);
    ctx.stroke();
    setStrokePoints((prevPoints) => [...prevPoints, { x, y }]);
  };

  const endDrawing = () => {
    setIsDrawing(false);
    handleStrokesChange();
    setStrokePoints([]);
  };

  const clearCanvas = (event) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setHasDrawn(false);
    setSignatureDataURL('');
    setHasValidStroke(false);
    if (event?.target?.blur) event.target.blur();
  };

  return (
    <>
      <canvas
        ref={canvasRef}
        width="350"
        height="150"
        style={{ border: '1px solid black', touchAction: 'none' }}
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={endDrawing}
        onMouseOut={endDrawing}
        onTouchStart={startDrawing}
        onTouchMove={draw}
        onTouchEnd={endDrawing}
      ></canvas>

      {hasValidStroke && (
        <button
          onClick={clearCanvas}
          style={{
            marginTop: '10px',
            marginLeft: 5,
            userSelect: 'none',
            fontFamily: fontPalette.primaryLight
          }}
        >
          Clear
        </button>
      )}
    </>
  );
};

export default Canvas;
